<template>
	<el-row class="points-show">
		<el-col :span="20">
			定制故事
		</el-col>
		<el-col :span="4">
			<el-button size="mini" type="primary" @click="productAttrAdd"> 上传定制故事 </el-button>
		</el-col>
		<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>类型标签：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="matStyle">
						<el-option v-for="item in matStyleList" :key="item.dicId" :label="item.dicDesc"
							:value="item.dicId" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="4">
				<el-button size="mini" type="primary" style="margin-left: 10px;" @click="search">搜索</el-button>
			</el-col>
		</el-row>
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column prop="matId" label="ID" />
				<el-table-column label="故事配图">
					<template slot-scope="scope">
						<el-image
							:src="tableData[scope.$index].matImg.split(',')[0] + '?x-oss-process=image/resize,w_50'"
							fit="fill" :preview-src-list="tableData[scope.$index].matImg.split(',')" />
					</template>
				</el-table-column>
				<el-table-column prop="matInfo" label="故事内容" />
				<el-table-column label="内容类型" prop="matName" />
				<el-table-column prop="status" label="素材修改">
					<el-button size="mini" slot-scope="scope" @click="updateScattered(scope.row)">
						编辑素材
					</el-button>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total,prev, pager, next" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange">
			</el-pagination>
		</el-col>
		<!-- 弹窗类组件 -->
		<el-col :span="24">
			<!-- 素材表单 -->
			<el-dialog title="上传定制故事" :visible.sync="dialogFormVisible" width="32%">
				<el-form :model="form" label-position="right" label-width="100px">
					<el-form-item label="图片/视频" prop="matImg">
						<el-button @click="chooseRadio(20)" type="primary" size="mini" style="margin-bottom: 10px;">
							图片库上传
						</el-button>

						<el-upload class="hide" :action="uploadUrl" :multiple="true" list-type="picture-card"
							:limit="20" :on-success="getPictrueURL" accept=".jpg,.png,.jpeg,.mp4,.avi"
							:file-list="fileList" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
							:on-error="handleError">
							<i class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">
								只能上传jpg/png文件，最多上传20张图片
							</div>
							<!-- <div slot="tip" class="el-upload__tip">
								当前已上传：{{form.matImg.split(",").length-1}}
							</div> -->
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" @close="imagePrevClosed" size="tiny" append-to-body>
							<video v-if="dialogImageUrl.substring(0, 4) == 'blob'" :src="dialogImageUrl" class="avatar"
								controls="controls">您的浏览器不支持视频播放</video>
							<img v-else width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
					</el-form-item>

					<el-form-item label="文字类内容">
						<el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="form.matInfo">
						</el-input>
					</el-form-item>
					<el-form-item label="类型标签">
						<el-select placeholder="请选择" clearable size="mini" v-model="form.matStyle">
							<el-option v-for="item in matStyleList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click="closeUpdate">取 消</el-button>
					<el-button size="mini" type="primary" @click="addScattered">确 定</el-button>
				</div>
			</el-dialog>
		</el-col>
		<el-drawer title="图片选择" :visible.sync="drawer" direction="rtl" size="40%">
			<SelectPicture :imgNum="20" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>
<script>
	import httpClient from '../../../util/request.js';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			SelectPicture
		},
		data() {
			return {
				radioValue: 0,
				drawer: false,
				tableHeight: window.innerHeight - 300,
				dialogFormVisible: false,
				uploadUrl: httpClient.imgUrl,
				fileList: [], // 商品图片上传控件图片数据源
				dialogDisplay: false, // 上传图片弹窗
				dialogImageUrl: '', //上传图片控件预览url
				// FORM表单
				form: {
					matId: '', //素材的ID
					matImg: '', //图片或视频地址
					matInfo: '', //文案或者话术
					matStyle: ''
				},
				formLabelWidth: '80px',
				loading: false,
				tableData: [],
				tableDataProduct: [],
				pageNum: 1,
				pageSize: 10,
				pageNum2: 1,
				pageSize2: 15,
				total: null,
				total2: null,
				// 13 定制故事的 上传
				// 素材的类型
				matStyle: '', //0图片1文章,其他的都是定制故事
				matStyleList: [],
				matStyleName: {}
			};
		},
		mounted() {
			// this.getScatteredDic();
			this.getScatteredDicAll();
		},
		methods: {
			chooseRadio() {
				this.drawer = true
			},
			getImg(e) {
				console.log([e]);
				this.fileList = []
				this.form.matImg = ''
				this.form.matImg = e
				e.split(',').forEach(item => {
					this.fileList.push({
						url: item
					})
				})
				console.log(this.fileList);
				this.drawer = false
			},
			bodyScale() {
				var devicewidth = document.documentElement.clientWidth;
				var scale = devicewidth / 1920; // 分母——设计稿的尺寸
				document.body.style.zoom = scale;
			},
			modeChange() {
				console.log(this.beginAndEndTime)
			},
			handleReferencePrice(value) {
				this.form.referencePrice = value;
			},
			// update素材
			updateScattered(rowData) {
				// 初始化标签数据
				this.resetFrom();
				this.fileList = [];
				var row = this.cloneData(rowData);
				row.matImg.split(',').forEach((item) => {
					if (item != '' && item != null && item != undefined) {
						this.fileList.push({
							url: item
						});
					}
				});
				this.form = row;
				this.dialogFormVisible = true;
				console.log(this.form)
			},
			closeUpdate() {
				this.resetFrom();
				this.fileList = [];
				this.dialogFormVisible = false;
			},


			null2str(data) {
				for (let x in data) {
					if (x != 'userAppealLabelIds' && x != 'userTypeLabelIds') {
						if (data[x] == null) { // 如果是null 把直接内容转为 ''
							data[x] = '';
						}
					}
				}
				return data;
			},
			// 这就可以进行上传操作了铁子
			addScattered() {
				var params = this.null2str(this.form);
				console.log(params);
				if (params.matStyle == "" || params.matStyle == undefined || params.matStyle == null) {
					this.$message.error("请选择类型标签");
					return;
				}
				this.loading = true;
				// 数据重组
				// if (params.matImg.length > 0 && params.matId == '') {
				// 	params.matImg = params.matImg.substr(0, params.matImg.length - 1);
				// }
				console.log(params);
				if (params.matId == '') {
					params.memberId = this.$store.state.memberId;
					// 新增就完事了嗷铁子
					return this.$http.post('/api/source/matScatteredMat/add', params).then(res => {
						if (res.data.status == 0) {
							this.$message.success("增加成功");
						} else {
							this.$message.error("增加失败");
						}
					}).finally(res => {
						this.dialogFormVisible = false;
						this.resetFrom();
						this.fileList = [];
						this.loading = false;
						this.resetSearch();
						this.getList();
					});
				}
				if (params.matId != '') {
					return this.$http.post('/api/source/matScatteredMat/update', params).then(res => {
						if (res.data.status == 0) {
							this.$message.success("修改成功");
						} else {
							this.$message.error("修改失败");
						}
					}).finally(res => {
						this.dialogFormVisible = false;
						this.resetFrom();
						this.fileList = [];
						this.loading = false;
						this.resetSearch();
						this.getList();
					});
				}
			},
			resetFrom() {
				this.form = {
					matId: '', //素材的ID
					matImg: '', //图片或视频地址
					matInfo: '', //文案或者话术
					matStyle: ''
				}
			},
			resetSearch() {
				this.matStyle = '';
			},

			productAttrAdd() {
				// 打开增加素材的窗口
				this.resetSearch();
				this.resetFrom();
				this.fileList = [];
				this.dialogFormVisible = true;
			},
			// 搜索
			search() {
				this.loading = true;
				let url = '/api/source/matScatteredMat/extraListPage';
				url = url + "?pageNum=" + 0 + "&pageSize=" + this.pageSize;
				var params = {
					matStyle: this.matStyle
				}
				return this.$http.post(url, params).then(res => {
					var dataList = res.data.data.list;
					dataList.forEach(element => {
						element.matName = this.matStyleName[element.matStyle]
					})
					this.tableData = dataList;
					this.total = res.data.data.total;
				}).catch(error => {
					console.log(error);
				}).finally(res => {
					this.loading = false;
				});
			},
			getList() {
				this.loading = true;
				let url = '/api/source/matScatteredMat/extraListPage';
				url = url + "?pageNum=" + this.pageNum + "&pageSize=" + this.pageSize
				var params = {
					matStyle: this.matStyle
				}
				return this.$http.post(url, params).then(res => {
					var dataList = res.data.data.list;
					dataList.forEach(element => {
						element.matName = this.matStyleName[element.matStyle]
					})
					this.tableData = dataList;
					this.total = res.data.data.total;
				}).catch(error => {
					console.log(error);
				}).finally(res => {
					this.loading = false;
				});
			},

			// 获取一系列的标签
			getScatteredDicAll() {
				this.loading = true;
				// 请求1 2 3 6 7 
				var dicTypeS = [13];
				var dicTypeValue = {
					13: 190
				};
				dicTypeS.forEach(element => {
					this.$http.get("/api/source/matDic/selectByParentId?pid=" + dicTypeValue[element], {}).then(
						res => {
							this.matStyleName = {};
							res.data.data.forEach(element => {
								this.matStyleName[element.dicId] = element.dicDesc
							});
							var matStylelI = [{
								dicDesc: '请选择',
								dicId: ''
							}]
							this.matStyleList = matStylelI.concat(res.data.data);
							this.getList();
						}).finally(res => {});
				});
				this.loading = false;
			},
			clickProductIs(product) {
				this.form.productId = product.id;
				this.form.productName = product.name;
				this.table = false;
			},
			// 获取图片地址，调用接口后端返回上传地址
			getPictrueURL(response, file, fileList) {
				if (this.form.matImg[this.form.matImg.length - 1] == ',') {
					this.form.matImg += response.data + ',';
				} else {
					if (this.form.matImg.length > 0) {
						this.form.matImg += ',' + response.data + ',';
					} else {
						this.form.matImg += response.data + ',';
					}
				}
			},
			// 图片预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},

			// 图片预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = ''
			},
			// 图片上传框删除一个图片
			handleRemove(file, fileList) {
				let files = this.form.matImg.split(',');
				files.splice(files.indexOf(file.url), 1);
				this.form.matImg = files.length === 0 ? '' : files.join(',');
			},
			handleSuccess(res, file, fileList) {
				if (res.status === 0) {
					this.$message({
						message: '上传成功！',
						type: 'success'
					});
					this.fileList = [];
				} else {
					this.$message({
						message: res.msg,
						type: 'error'
					});
				}
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getList();
			},

			cloneData(obj) {
				//判断是对象，就进行循环复制
				if (typeof obj === 'object' && obj != null) {
					// 区分是数组还是对象，创建空的数组或对象
					var o = Object.prototype.toString.call(obj).slice(8, -1) === "Array" ? [] : {};
					for (var k in obj) {
						// 如果属性对应的值为对象，则递归复制
						if (typeof obj[k] === 'object' && obj[k] != null) {
							o[k] = this.cloneData(obj[k])
						} else {
							o[k] = obj[k];
						}
					}
				} else { //不为对象，直接把值返回
					return obj;
				}
				return o;
			},
			handleError(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	.productAttrAddBox {
		width: 300px;
	}

	/deep/.el-drawer__open .el-drawer.rtl {
		overflow: auto;
	}

	.pagination {
		margin-left: 50%;
		margin-top: 20px;
		z-index: 2;
		transform: translateX(-50%);
	}

	.typeDiv {
		padding: 2px 8px;
		margin: 1px;
		font-size: 12px;
		height: 14px;
		line-height: 14px;
		background: #808080ad;
		color: white;
		border-radius: 11px;
	}

	/deep/.el-drawer {
		overflow: auto;
	}

	/deep/.el-drawer__body {
		overflow: auto;
	}

	/deep/.el-input {
		width: auto;
	}

	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>
